import getStore from 'services/getStore';
import { getBlockFromState } from 'selectors/block';

export default id => getBlockFromState(getStore().getState(), id);
